import { render, staticRenderFns } from "./addMain.vue?vue&type=template&id=d902a92a"
import script from "./addMain.vue?vue&type=script&lang=js"
export * from "./addMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d902a92a')) {
      api.createRecord('d902a92a', component.options)
    } else {
      api.reload('d902a92a', component.options)
    }
    module.hot.accept("./addMain.vue?vue&type=template&id=d902a92a", function () {
      api.rerender('d902a92a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/addMain.vue"
export default component.exports